// src/npcInteractions.js

export const npcs = [
  {
    id: 1,
    name: 'Hollow Merchant',
    zoneId: 1,
    position_x: 2,
    position_y: 3,
    dialogue: [
      {
        text: 'Welcome to the Crypt, traveler. Got any coin to spend? I don’t deal with broke adventurers!',
        outcome: 'branch',
        options: [
          {
            text: 'What do you have for sale?',
            outcome: 'trade',
            response: [
              {
                text: 'I’ve got the best goods in the Crypt—potions, weapons, you name it! But it’ll cost you!',
                outcome: 'trade',
              },
              {
                text: 'Don’t waste my time if you’re not buying. Anything else?',
                outcome: 'branch',
                options: [
                  {
                    text: 'Tell me about the Crypt.',
                    outcome: 'log',
                    response: [
                      {
                        text: 'It’s a cursed place, full of restless souls. The deeper you go, the worse it gets. Be careful, traveler—or don’t, more loot for me!',
                        outcome: 'close',
                      },
                    ],
                  },
                  {
                    text: 'Can I sell you something?',
                    outcome: 'sell',
                    response: [
                      {
                        text: 'Let’s see what you’ve got. I’ll pay in gold or ectoplasm, but don’t expect me to overpay!',
                        outcome: 'sell',
                      },
                      {
                        text: 'Oh, something from the Shattered Vestibule? I’ll pay extra for that!',
                        outcome: 'sell',
                        condition: { itemZoneId: 1 }, // Bonus for items from Zone 1
                      },
                    ],
                  },
                  { text: 'Goodbye.', outcome: 'close' },
                ],
              },
            ],
          },
          {
            text: 'Got any quests for me?',
            outcome: 'quest',
            response: [
              {
                text: 'Aye, I could use help clearing out some skeletons. Interested?',
                outcome: 'quest',
                questId: 1,
              },
              { text: 'Come back when it’s done, eh?', outcome: 'close' },
            ],
          },
          {
            text: 'Tell me about yourself.',
            outcome: 'log',
            response: [
              {
                text: 'I’ve been trading in these halls for decades. The dead don’t scare me anymore, but they sure keep me busy. Need anything?',
                outcome: 'branch',
                options: [
                  { text: 'Let’s trade.', outcome: 'trade' },
                  { text: 'Goodbye.', outcome: 'close' },
                ],
              },
            ],
          },
          { text: 'Not now.', outcome: 'log', response: [{ text: 'Safe travels then!', outcome: 'close' }] },
        ],
      },
    ],
    available_quests: [1, 6, 9, 14, 15, 16, 32],
    trade_items: [
      { item_name: 'Healing Potion', cost: 5, ectoplasm_cost: 5 },
      { item_name: 'Rusty Sword', cost: 10, ectoplasm_cost: 8 },
      { item_name: 'Minor Mana Shard', cost: 15, ectoplasm_cost: 10 },
    ],
    sellPreferences: {
      preferredItems: { zoneId: 1 }, // Pays 50% more for items from Zone 1
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 }, // Percentage of ectoplasm_cost
    },
    sellCurrency: 'mixed', // Pays in gold or ectoplasm
  },
  {
    id: 2,
    name: 'Drowned Oracle',
    zoneId: 5,
    position_x: 5,
    position_y: 5,
    dialogue: [
      {
        text: 'The waters whisper secrets, mortal. Will you heed their call?',
        outcome: 'branch',
        options: [
          {
            text: 'What do the waters say?',
            outcome: 'log',
            response: [
              { text: 'A relic lies in the Sunken Library, hidden beneath ink and shadow. Will you retrieve it for me?', outcome: 'quest', questId: 5 },
              { text: 'The tides wait for no one. Decide quickly.', outcome: 'close' },
            ],
          },
          {
            text: 'Tell me about the Flooded Catacombs.',
            outcome: 'log',
            response: [
              { text: 'Once a sacred place, now drowned in sorrow. The spirits here weep, and the beasts hunger. Tread lightly.', outcome: 'close' },
            ],
          },
          {
            text: 'What lies in the Sunken Library?',
            outcome: 'log',
            response: [
              { text: 'Knowledge drowned in darkness… Ink Specters guard tomes of power. A great evil stirs there—beware the silent archives.', outcome: 'close' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I have no use for weapons, but I’ll take consumables or accessories. Show me.', outcome: 'sell' },
            ],
          },
          {
            text: 'I’m not interested.',
            outcome: 'log',
            response: [
              { text: 'The tides guide you, even if you refuse.', outcome: 'close' },
              { text: 'Return when you’re ready to listen.', outcome: 'close' },
            ],
          },
        ],
      },
    ],
    available_quests: [5, 33], // Quest 5: "The Oracle’s Relic", Quest 33: "Silence the Song"
    trade_items: [],
    sellPreferences: {
      preferredItems: { type: ['consumable', 'accessory'] }, // Only buys consumables and accessories
      priceModifier: 1.0,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm', // Pays only in ectoplasm
  },
  {
    id: 3,
    name: 'Ember Scribe',
    zoneId: 10,
    position_x: 4,
    position_y: 6,
    dialogue: [
      {
        text: 'I forge great things, but this blasted heat slows me down! Will you help me, or are you just here to waste my time?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need?',
            outcome: 'quest',
            response: [
              { text: 'I need an Ember Core from the Smoldering Anvils—and deal with those Ember Spirits while you’re at it! They’re ruining my work!', outcome: 'quest', questId: 20 },
              { text: 'Don’t dawdle! I need those materials now!', outcome: 'close' },
            ],
          },
          {
            text: 'Can you forge something for me now?',
            outcome: 'trade',
            response: [
              { text: 'I’ve got a few items ready, but they’ll cost you. What do you have to trade? Hurry up!', outcome: 'trade' },
            ],
          },
          {
            text: 'Tell me about the Obsidian Forges.',
            outcome: 'log',
            response: [
              { text: 'This place was once a great forge for the ancient kings. Now, it’s overrun with fire elementals and worse. The heat’s unbearable—makes my work harder!', outcome: 'close' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'Got any fire-related items? I’ll pay well for those. Otherwise, don’t waste my time!', outcome: 'sell' },
              { text: 'An Ember Pendant? Perfect for my work—I’ll pay extra!', outcome: 'sell', condition: { itemId: 26 } },
            ],
          },
          { text: 'Not now.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [20, 34], // Quest 20: "Forge the Flame", Quest 34: "Fuel the Forge"
    trade_items: [
      { item_name: 'Rusty Sword', cost: 3, ectoplasm_cost: 3 },
      { item_name: 'Tome Guardian’s Shield', cost: 20, ectoplasm_cost: 15 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [26, 25] }, // Pays 50% more for Ember Pendant (ID: 26) and Obsidian Hammer (ID: 25)
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold', // Pays only in gold
  },
  {
    id: 4,
    name: 'Outpost Trader',
    zoneId: 2,
    position_x: 3,
    position_y: 4,
    dialogue: [
      {
        text: 'I’ve set up a small outpost here. Need supplies or information?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you have for sale?',
            outcome: 'trade',
            response: [
              { text: 'I’ve got some basic supplies—potions, a few weapons. Take a look.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'Let’s see what you’ve got. I’ll pay in gold for anything useful.', outcome: 'sell' },
              { text: 'Something from the Flooded Catacombs? I’ll pay extra for that!', outcome: 'sell', condition: { itemZoneId: 2 } },
            ],
          },
          {
            text: 'Tell me about this place.',
            outcome: 'log',
            response: [
              { text: 'The Flooded Catacombs are a dangerous place—full of waterlogged spirits and worse. Be careful down here.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [2], // Quest 2: "Rescue the Lost Trader"
    trade_items: [
      { item_name: 'Healing Potion', cost: 5, ectoplasm_cost: 5 },
      { item_name: 'Rusty Sword', cost: 10, ectoplasm_cost: 8 },
    ],
    sellPreferences: {
      preferredItems: { zoneId: 2 }, // Pays 50% more for items from Zone 2
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold', // Pays only in gold
  },
  {
    id: 6,
    name: 'Hermit',
    zoneId: 7,
    position_x: 1,
    position_y: 1,
    dialogue: [
      {
        text: 'I’ve lived in these tombs for years. What brings you here?',
        outcome: 'branch',
        options: [
          {
            text: 'I’m looking for a quest.',
            outcome: 'quest',
            response: [
              { text: 'I need a rare herb that grows in the Tidal Tombs. Can you find it for me?', outcome: 'quest', questId: 10 },
              { text: 'Be careful—the waters here are treacherous.', outcome: 'close' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Tidal Tombs. Show me what you have.', outcome: 'sell' },
              { text: 'Something from the Tidal Tombs? I’ll pay extra for that!', outcome: 'sell', condition: { itemZoneId: 7 } },
            ],
          },
          {
            text: 'Tell me about the Tidal Tombs.',
            outcome: 'log',
            response: [
              { text: 'These tombs were once a resting place for ancient warriors, now flooded and forgotten. The spirits here are restless.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [10], // Quest 10: "Rare Herb"
    trade_items: [],
    sellPreferences: {
      preferredItems: { zoneId: 7 }, // Pays 50% more for items from Zone 7
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold', // Pays only in gold
  },
  {
    id: 7,
    name: 'Survivor Camp',
    zoneId: 1,
    position_x: 5,
    position_y: 5,
    dialogue: [
      {
        text: 'We’re barely holding on here. Can you help us survive?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need?',
            outcome: 'quest',
            response: [
              { text: 'We lost an heirloom in the Shattered Vestibule. Can you retrieve it for us?', outcome: 'quest', questId: 9 },
              { text: 'Please hurry—we need all the help we can get.', outcome: 'close' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'We’ll take anything useful. Show us what you have.', outcome: 'sell' },
              { text: 'Something from the Shattered Vestibule? We’ll pay extra for that!', outcome: 'sell', condition: { itemZoneId: 1 } },
            ],
          },
          {
            text: 'Tell me about this place.',
            outcome: 'log',
            response: [
              { text: 'The Shattered Vestibule is the entrance to this cursed crypt. Skeletons and rats are everywhere—be careful.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [9], // Quest 9: "Lost Heirloom"
    trade_items: [],
    sellPreferences: {
      preferredItems: { zoneId: 1 }, // Pays 50% more for items from Zone 1
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold', // Pays only in gold
  },  
  {
    id: 8,
    name: 'Smith',
    zoneId: 40,
    position_x: 6,
    position_y: 3,
    condition: { monsterKills: { monsterId: 57, count: 3 } }, // Appears after killing 3 Ink Specters
    dialogue: [
      {
        text: 'Thanks for clearing out those Ink Specters—I can finally work in peace! Need some armor crafted?',
        outcome: 'branch',
        options: [
          {
            text: 'What materials do you need?',
            outcome: 'quest',
            response: [
              { text: 'I need an Ember Core from the Obsidian Forges. It’s a rare material, but I can make you something great with it.', outcome: 'quest', questId: 20 },
              { text: 'Come back when you have it.', outcome: 'close' },
            ],
          },
          {
            text: 'Can I buy something from you?',
            outcome: 'trade',
            response: [
              { text: 'I’ve got some armor pieces ready. Take a look, but they’ll cost you ectoplasm.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'Show me what you’ve got. I’ll pay in ectoplasm for anything useful.', outcome: 'sell' },
              { text: 'An Iron Construct Core? I can use that—I’ll pay extra!', outcome: 'sell', condition: { itemId: 28 } },
            ],
          },
          {
            text: 'Tell me about yourself.',
            outcome: 'log',
            response: [
              { text: 'I’ve been a smith all my life, but I got trapped in this cursed library. Now I make do with what I can find.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [20], // Quest 20: "Forge the Flame"
    trade_items: [
      { item_name: 'Leather Armor', cost: 10, ectoplasm_cost: 10 },
      { item_name: 'Healing Potion', cost: 5, ectoplasm_cost: 5 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [28] }, // Pays 50% more for Iron Construct Core
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm', // Pays only in ectoplasm
  },
  {
    id: 9,
    name: 'Last Watcher',
    zoneId: 41,
    position_x: 2,
    position_y: 7,
    dialogue: [
      {
        text: 'The Veil is tearing apart. Help me seal a rift, or all will be lost!',
        outcome: 'branch',
        options: [
          {
            text: 'I’ll help you seal the rift.',
            outcome: 'quest',
            response: [
              { text: 'Good. Close the rift in the Soulrift Nexus. We cannot let the Veil collapse!', outcome: 'quest', questId: 8 },
              { text: 'Hurry—the Veil must hold!', outcome: 'close' },
            ],
          },
          {
            text: 'What’s your issue with the Exiled Mage?',
            outcome: 'log',
            response: [
              {
                text: 'That fool meddles with forces he cannot control! His experiments weaken the Veil. If you side with him, you’re no ally of mine.',
                outcome: 'branch',
                options: [
                  {
                    text: 'I’ll side with you.',
                    outcome: 'log',
                    response: [
                      { text: 'A wise choice. Now, about that rift…', outcome: 'quest', questId: 8 },
                    ],
                  },
                  {
                    text: 'I need to think about it.',
                    outcome: 'close',
                    response: [{ text: 'Don’t take too long. The Veil waits for no one.', outcome: 'close' }],
                  },
                ],
              },
            ],
          },
          { text: 'Not now.', outcome: 'close' },
        ],
      },
      {
        text: 'A Veil Lord escaped when the rift was sealed. Hunt it down before it causes more chaos!',
        outcome: 'quest',
        questId: 25,
        condition: { questCompleted: 8 }, // Only available after completing Quest 8
      },
    ],
    available_quests: [8, 25], // Quest 8: "Seal the Rift", Quest 25: "Nexus Purge"
    trade_items: [],
    sellPreferences: null, // Doesn’t buy items
    sellCurrency: null,
  },
  {
    id: 10,
    name: 'Exiled Mage',
    zoneId: 41,
    position_x: 3,
    position_y: 6,
    dialogue: [
      {
        text: 'I trade spells for ectoplasm, and I need Veil Shards for my research. Care to make a deal?',
        outcome: 'branch',
        options: [
          {
            text: 'I’ll help with your research.',
            outcome: 'quest',
            response: [
              { text: 'Excellent! Bring me 5 Veil Shards for my experiment. They’re scattered across the Soulrift Nexus.', outcome: 'quest', questId: 35 },
              { text: 'Don’t let the Last Watcher interfere. He doesn’t understand progress.', outcome: 'close' },
            ],
          },
          {
            text: 'What’s your issue with the Last Watcher?',
            outcome: 'log',
            response: [
              {
                text: 'That old fool clings to tradition, trying to seal the Veil when we could harness its power! Side with me, and I’ll teach you great magic.',
                outcome: 'branch',
                options: [
                  {
                    text: 'I’ll side with you.',
                    outcome: 'log',
                    response: [
                      { text: 'A wise choice. Now, about those Veil Shards…', outcome: 'quest', questId: 35 },
                    ],
                  },
                  {
                    text: 'I need to think about it.',
                    outcome: 'close',
                    response: [{ text: 'Don’t take too long. Power waits for no one.', outcome: 'close' }],
                  },
                ],
              },
            ],
          },
          { text: 'Let’s trade.', outcome: 'trade' },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything magical—show me what you have.', outcome: 'sell' },
            ],
          },
          { text: 'Not now.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [25, 35], // Quest 25: "Nexus Purge", Quest 35: "Mage’s Experiment"
    trade_items: [
      { item_name: 'Veil Shard', cost: 10, ectoplasm_cost: 10 },
    ],
    sellPreferences: {
      preferredItems: { type: ['consumable', 'accessory'] }, // Buys magical items
      priceModifier: 1.0,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm', // Pays only in ectoplasm
  },
  {
    id: 14,
    name: 'Crypt Guard',
    zoneId: 4,
    position_x: 3,
    position_y: 3,
    dialogue: [
      {
        text: 'These crypts are under my protection. Help me keep them safe, traveler.',
        outcome: 'branch',
        options: [
          {
            text: 'How can I help?',
            outcome: 'quest',
            response: [
              { text: 'Skeletal Archers are a threat to this place. Defeat 5 of them to secure the crypts.', outcome: 'quest', questId: 37 },
              { text: 'Return when the deed is done.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I have some basic gear for you. It’ll cost you, though.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'Show me what you’ve got. I’ll pay in gold for anything useful.', outcome: 'sell' },
              { text: 'Something from the Guarded Crypts? I’ll pay extra for that!', outcome: 'sell', condition: { itemZoneId: 4 } },
            ],
          },
          {
            text: 'Tell me about the Guarded Crypts.',
            outcome: 'log',
            response: [
              { text: 'These crypts hold the remains of ancient warriors. The Skeletal Archers guard them fiercely—be on your guard.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [37],
    trade_items: [
      { item_name: 'Rusty Sword', cost: 10, ectoplasm_cost: 8 },
      { item_name: 'Leather Armor', cost: 12, ectoplasm_cost: 10 },
    ],
    sellPreferences: {
      preferredItems: { zoneId: 4 },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold',
  },
  {
    id: 15,
    name: 'Royal Chronicler',
    zoneId: 6,
    position_x: 2,
    position_y: 4,
    dialogue: [
      {
        text: 'I record the history of the ancient kings. Will you aid me in my work?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need?',
            outcome: 'quest',
            response: [
              { text: 'A Royal Relic lies somewhere in this chamber. Find it so I can document its history.', outcome: 'quest', questId: 38 },
              { text: 'Be careful—the spirits here are restless.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I have some items that might aid your journey. Take a look.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from this chamber. Show me what you have.', outcome: 'sell' },
              { text: 'Something from the Royal Audience Chamber? I’ll pay extra for that!', outcome: 'sell', condition: { itemZoneId: 6 } },
            ],
          },
          {
            text: 'Tell me about this chamber.',
            outcome: 'log',
            response: [
              { text: 'This was once the audience chamber of great kings. Now, Spectral Heralds haunt its halls, guarding their legacy.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [38],
    trade_items: [
      { item_name: 'Healing Potion', cost: 5, ectoplasm_cost: 5 },
      { item_name: 'Spectral Shard', cost: 8, ectoplasm_cost: 8 },
    ],
    sellPreferences: {
      preferredItems: { zoneId: 6 },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm',
  },
  {
    id: 16,
    name: 'Abyssal Diver',
    zoneId: 9,
    position_x: 4,
    position_y: 2,
    dialogue: [
      {
        text: 'I dive into the depths for treasures. Care to join me in this watery abyss?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need help with?',
            outcome: 'quest',
            response: [
              { text: 'Abyssal Eels are making my dives dangerous. Defeat 3 of them to clear the way.', outcome: 'quest', questId: 39 },
              { text: 'Come back when it’s done.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I’ve found some items in the depths. They’re yours for a price.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Abyssal Cistern. Show me what you have.', outcome: 'sell' },
              { text: 'Something from the cistern? I’ll pay extra for that!', outcome: 'sell', condition: { itemZoneId: 9 } },
            ],
          },
          {
            text: 'Tell me about the Abyssal Cistern.',
            outcome: 'log',
            response: [
              { text: 'A deep, flooded chamber filled with Abyssal Eels and other dangers. But the treasures here are worth the risk.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [39],
    trade_items: [
      { item_name: 'Abyssal Scale', cost: 10, ectoplasm_cost: 10 },
      { item_name: 'Minor Mana Shard', cost: 15, ectoplasm_cost: 10 },
    ],
    sellPreferences: {
      preferredItems: { zoneId: 9 },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold',
  },
  {
    id: 17,
    name: 'Forge Worker',
    zoneId: 11,
    position_x: 5,
    position_y: 3,
    dialogue: [
      {
        text: 'The forges are a mess! Help me get things under control, will you?',
        outcome: 'branch',
        options: [
          {
            text: 'What’s the problem?',
            outcome: 'quest',
            response: [
              { text: 'Ember Fiends are causing chaos in the Forge Depths. Defeat 4 of them to restore order.', outcome: 'quest', questId: 40 },
              { text: 'Hurry—the forges can’t take much more of this!', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I’ve got some fire-forged items for you. Take a look.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'Got any fire-related items? I’ll pay well for those.', outcome: 'sell' },
              { text: 'An Ember Shard? Perfect—I’ll pay extra!', outcome: 'sell', condition: { itemId: 24 } },
            ],
          },
          {
            text: 'Tell me about the Forge Depths.',
            outcome: 'log',
            response: [
              { text: 'The heart of the Obsidian Forges, where the heat is unbearable and Ember Fiends roam. It’s a tough place to work.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [40],
    trade_items: [
      { item_name: 'Ember Shard', cost: 12, ectoplasm_cost: 12 },
      { item_name: 'Obsidian Hammer', cost: 20, ectoplasm_cost: 18 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [24] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold',
  },
  {
    id: 18,
    name: 'Crystal Sage',
    zoneId: 14,
    position_x: 2,
    position_y: 5,
    dialogue: [
      {
        text: 'The crystals of the Veil hold great power. Will you assist me in my studies?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need?',
            outcome: 'quest',
            response: [
              { text: 'I need 3 Crystal Shards for my research. They’re scattered across the Crystal Spires.', outcome: 'quest', questId: 41 },
              { text: 'Be careful—the Veil’s energy is unstable here.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I have some magical items infused with the Veil’s energy. Take a look.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Crystal Spires. Show me what you have.', outcome: 'sell' },
              { text: 'A Crystal Shard? I’ll pay extra for that!', outcome: 'sell', condition: { itemId: 30 } },
            ],
          },
          {
            text: 'Tell me about the Crystal Spires.',
            outcome: 'log',
            response: [
              { text: 'Towering crystals that pulse with the Veil’s energy. The Veil Stalkers here guard them fiercely.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [41],
    trade_items: [
      { item_name: 'Crystal Shard', cost: 15, ectoplasm_cost: 15 },
      { item_name: 'Minor Mana Shard', cost: 10, ectoplasm_cost: 10 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [30] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm',
  },
  {
    id: 19,
    name: 'Gauntlet Sentinel',
    zoneId: 18,
    position_x: 3,
    position_y: 2,
    dialogue: [
      {
        text: 'I guard the Gauntlet of the Eternal Throne. Prove your worth, warrior!',
        outcome: 'branch',
        options: [
          {
            text: 'How can I prove myself?',
            outcome: 'quest',
            response: [
              { text: 'Defeat 5 King’s Shades in the Guardian’s Gauntlet. Only then will you earn my respect.', outcome: 'quest', questId: 42 },
              { text: 'Do not fail—these shades are relentless.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I have weapons worthy of a true warrior. Take a look.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Gauntlet. Show me what you have.', outcome: 'sell' },
              { text: 'A King’s Crest? I’ll pay extra for that!', outcome: 'sell', condition: { itemId: 35 } },
            ],
          },
          {
            text: 'Tell me about the Guardian’s Gauntlet.',
            outcome: 'log',
            response: [
              { text: 'A deadly trial leading to the Eternal Throne. King’s Shades test all who dare to pass.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [42],
    trade_items: [
      { item_name: 'Spectral Bow', cost: 25, ectoplasm_cost: 20 },
      { item_name: 'King’s Crest', cost: 30, ectoplasm_cost: 25 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [35] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold',
  },
  {
    id: 20,
    name: 'Sand Nomad',
    zoneId: 24,
    position_x: 4,
    position_y: 4,
    dialogue: [
      {
        text: 'The Blighted Sands are harsh, but I survive. Will you help me endure?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need?',
            outcome: 'quest',
            response: [
              { text: 'Sand Wraiths are a constant threat. Defeat 4 of them to make the sands safer.', outcome: 'quest', questId: 43 },
              { text: 'Return when it’s done.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I’ve scavenged some items from the sands. They’re yours for a price.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Blighted Sands. Show me what you have.', outcome: 'sell' },
              { text: 'Sand Wraith Essence? I’ll pay extra for that!', outcome: 'sell', condition: { itemId: 41 } },
            ],
          },
          {
            text: 'Tell me about the Blighted Sands.',
            outcome: 'log',
            response: [
              { text: 'A cursed desert where the sand itself seems alive. Sand Wraiths haunt this place, preying on the unwary.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [43],
    trade_items: [
      { item_name: 'Sand Wraith Essence', cost: 15, ectoplasm_cost: 15 },
      { item_name: 'Ashen Cloak', cost: 10, ectoplasm_cost: 10 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [41] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold',
  },
  {
    id: 21,
    name: 'Frost Hunter',
    zoneId: 27,
    position_x: 2,
    position_y: 3,
    dialogue: [
      {
        text: 'I hunt the beasts of this frozen tundra. Join me in the chase, traveler.',
        outcome: 'branch',
        options: [
          {
            text: 'What are you hunting?',
            outcome: 'quest',
            response: [
              { text: 'Frost Wolves are a menace in the Icebound Hollow. Defeat 3 of them for me.', outcome: 'quest', questId: 44 },
              { text: 'Be careful—the cold bites as hard as the wolves.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I’ve got some items to help you survive the cold. Take a look.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Icebound Hollow. Show me what you have.', outcome: 'sell' },
              { text: 'A Frost Wolf Pelt? I’ll pay extra for that!', outcome: 'sell', condition: { itemId: 44 } },
            ],
          },
          {
            text: 'Tell me about the Icebound Hollow.',
            outcome: 'log',
            response: [
              { text: 'A frozen cavern in the Frostfang Tundra. Frost Wolves prowl here, and the cold is unrelenting.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [44],
    trade_items: [
      { item_name: 'Frost Wolf Pelt', cost: 15, ectoplasm_cost: 15 },
      { item_name: 'Frosted Blade', cost: 20, ectoplasm_cost: 18 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [44] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'gold',
  },
  {
    id: 22,
    name: 'Vine Warden',
    zoneId: 31,
    position_x: 3,
    position_y: 5,
    dialogue: [
      {
        text: 'I protect the flora of the Verdant Abyss. Will you help me preserve this place?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need?',
            outcome: 'quest',
            response: [
              { text: 'I need 5 Thorned Vines to strengthen the abyss’s defenses. Gather them for me.', outcome: 'quest', questId: 45 },
              { text: 'Be careful—the creatures here are hostile.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I have some nature-infused items for you. Take a look.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Overgrown Depths. Show me what you have.', outcome: 'sell' },
              { text: 'Thorned Vines? I’ll pay extra for those!', outcome: 'sell', condition: { itemId: 50 } },
            ],
          },
          {
            text: 'Tell me about the Overgrown Depths.',
            outcome: 'log',
            response: [
              { text: 'A tangled maze of vines and roots in the Verdant Abyss. The Thorned Beasts here are dangerous.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [45],
    trade_items: [
      { item_name: 'Thorned Vine', cost: 12, ectoplasm_cost: 12 },
      { item_name: 'Healing Potion', cost: 5, ectoplasm_cost: 5 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [50] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm',
  },
  {
    id: 23,
    name: 'Storm Sentinel',
    zoneId: 35,
    position_x: 1,
    position_y: 4,
    dialogue: [
      {
        text: 'I watch over the Storm’s Eye. Help me maintain its balance.',
        outcome: 'branch',
        options: [
          {
            text: 'What needs to be done?',
            outcome: 'quest',
            response: [
              { text: 'Storm Ravens are disrupting the storm’s core. Defeat 3 of them to restore balance.', outcome: 'quest', questId: 46 },
              { text: 'Hurry—the storm grows restless.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I have storm-infused items for you. They’re powerful, but costly.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything storm-related. Show me what you have.', outcome: 'sell' },
              { text: 'A Storm Raven Feather? I’ll pay extra for that!', outcome: 'sell', condition: { itemId: 74 } },
            ],
          },
          {
            text: 'Tell me about the Storm’s Eye.',
            outcome: 'log',
            response: [
              { text: 'The heart of the Stormwracked Ridge, where the storm’s power is strongest. Storm Ravens guard this place.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [46],
    trade_items: [
      { item_name: 'Storm Raven Feather', cost: 20, ectoplasm_cost: 20 },
      { item_name: 'Thunder Bow', cost: 18, ectoplasm_cost: 18 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [74] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm',
  },
  {
    id: 24,
    name: 'Bog Witch',
    zoneId: 37,
    position_x: 2,
    position_y: 2,
    dialogue: [
      {
        text: 'The Murkshade Bog holds dark magic. Will you aid me in harnessing it?',
        outcome: 'branch',
        options: [
          {
            text: 'What do you need?',
            outcome: 'quest',
            response: [
              { text: 'I need 4 Murkshade Roots for my rituals. Gather them from the bog.', outcome: 'quest', questId: 47 },
              { text: 'Be careful—the swamp is treacherous.', outcome: 'close' },
            ],
          },
          {
            text: 'Got anything to trade?',
            outcome: 'trade',
            response: [
              { text: 'I have some magical items for you. They’re infused with the swamp’s power.', outcome: 'trade' },
            ],
          },
          {
            text: 'Can I sell you something?',
            outcome: 'sell',
            response: [
              { text: 'I’ll take anything from the Murkshade Bog. Show me what you have.', outcome: 'sell' },
              { text: 'Murkshade Roots? I’ll pay extra for those!', outcome: 'sell', condition: { itemId: 56 } },
            ],
          },
          {
            text: 'Tell me about the Murkshade Bog.',
            outcome: 'log',
            response: [
              { text: 'A dark, swampy place in the Veilswamp. The Murkshade Wisps here are dangerous, but the roots hold great power.', outcome: 'close' },
            ],
          },
          { text: 'Goodbye.', outcome: 'close' },
        ],
      },
    ],
    available_quests: [47],
    trade_items: [
      { item_name: 'Murkshade Root', cost: 15, ectoplasm_cost: 15 },
      { item_name: 'Minor Mana Shard', cost: 10, ectoplasm_cost: 10 },
    ],
    sellPreferences: {
      preferredItems: { itemId: [56] },
      priceModifier: 1.5,
      basePrice: { common: 0.5, uncommon: 0.75, rare: 1.0 },
    },
    sellCurrency: 'ectoplasm',
  },
];
  
export const quests = [
  {
    id: 1,
    title: 'Clear the Entry Hall',
    description: 'Defeat 5 Skeletons in the Shattered Vestibule - Entry Hall',
    zoneId: 1,
    objective_type: 'kill',
    objective_target: 'Skeleton',
    objective_count: 5,
    reward_type: 'item',
    reward_value: 'Healing Potion',
    reward_amount: 1,
  },
  {
    id: 2,
    title: 'Rescue the Lost Trader',
    description: 'Find the Outpost Trader in the Flooded Catacombs - Drowned Passage',
    zoneId: 2,
    objective_type: 'find',
    objective_target: 'Outpost Trader',
    objective_count: 1,
    reward_type: 'gold',
    reward_value: 50,
    reward_amount: 50,
  },
  {
    id: 3,
    title: 'Hunt the Spectral Siren',
    description: 'Eliminate 3 Spectral Sirens in the Flooded Catacombs - Drowned Passage',
    zoneId: 2,
    objective_type: 'kill',
    objective_target: 'Spectral Siren',
    objective_count: 3,
    reward_type: 'xp',
    reward_value: 30,
    reward_amount: 30,
  },
  {
    id: 4,
    title: 'Rescue the Outpost Trader',
    description: 'Find the Outpost Trader in the Flooded Catacombs - Drowned Passage',
    zoneId: 5,
    objective_type: 'find',
    objective_target: 'Outpost Trader',
    objective_count: 1,
    reward_type: 'gold',
    reward_value: 50,
    reward_amount: 50,
  },
  {
    id: 5,
    title: 'The Oracle’s Relic',
    description: 'Retrieve a relic from the Sunken Library for the Drowned Oracle',
    zoneId: 8,
    objective_type: 'find',
    objective_target: 'Relic',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Healing Potion',
    reward_amount: 1,
  },
  {
    id: 6,
    title: 'Clear the Entry Hall',
    description: 'Defeat 10 Bone Rats in the Shattered Vestibule - Entry Hall',
    zoneId: 1,
    objective_type: 'kill',
    objective_target: 'Bone Rat',
    objective_count: 10,
    reward_type: 'item',
    reward_value: 'Rusty Sword',
    reward_amount: 1,
  },
  {
    id: 7,
    title: 'Retrieve the Sunken Relic',
    description: 'Find a relic in the Sunken Library for the Hollow Seer',
    zoneId: 8,
    objective_type: 'find',
    objective_target: 'Relic',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Healing Potion',
    reward_amount: 1,
  },
  {
    id: 8,
    title: 'Seal the Rift',
    description: 'Close a rift in the Soulrift Nexus for the Last Watcher',
    zoneId: 15,
    objective_type: 'find',
    objective_target: 'Rift',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Spectral Bow',
    reward_amount: 1,
  },
  {
    id: 9,
    title: 'Lost Heirloom',
    description: 'Retrieve a lost heirloom in the Shattered Vestibule for the survivor camp',
    zoneId: 1,
    objective_type: 'find',
    objective_target: 'Heirloom',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Minor Mana Shard',
    reward_amount: 2,
  },
  {
    id: 10,
    title: 'Rare Herb',
    description: 'Retrieve a rare herb from the Tidal Tombs for the hermit',
    zoneId: 7,
    objective_type: 'find',
    objective_target: 'Rare Herb',
    objective_count: 1,
    reward_type: 'gold',
    reward_value: 30,
    reward_amount: 30,
  },
  {
    id: 11,
    title: 'Hunt the Spectral Siren',
    description: 'Eliminate 5 Spectral Sirens in the Flooded Catacombs - Drowned Passage',
    zoneId: 5,
    objective_type: 'kill',
    objective_target: 'Spectral Siren',
    objective_count: 5,
    reward_type: 'xp',
    reward_value: 50,
    reward_amount: 50,
  },
  {
    id: 12,
    title: 'Defeat the Elemental',
    description: 'Defeat 3 Lightning Elementals in Stormwracked Ridge',
    zoneId: 34,
    objective_type: 'kill',
    objective_target: 'Lightning Elemental',
    objective_count: 3,
    reward_type: 'xp',
    reward_value: 100,
    reward_amount: 100,
  },
  {
    id: 13,
    title: 'Cleanse the Veilswamp',
    description: 'Cleanse the corrupted tree in Veilswamp',
    zoneId: 38,
    objective_type: 'find',
    objective_target: 'Corrupted Tree',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Frosted Blade',
    reward_amount: 1,
  },
  {
    id: 14,
    title: 'Guard the Crypt',
    description: 'Defeat 8 Skeletal Archers in the Shattered Vestibule - Guarded Crypts',
    zoneId: 4,
    objective_type: 'kill',
    objective_target: 'Skeletal Archer',
    objective_count: 8,
    reward_type: 'item',
    reward_value: 'Leather Armor',
    reward_amount: 1,
  },
  {
    id: 15,
    title: 'Echoes of the Past',
    description: 'Find the Echo Shard in the Shattered Vestibule - Echoing Gallery',
    zoneId: 5,
    objective_type: 'find',
    objective_target: 'Echo Shard',
    objective_count: 1,
    reward_type: 'gold',
    reward_value: 40,
    reward_amount: 40,
  },
  {
    id: 16,
    title: 'Throne’s Wrath',
    description: 'Eliminate 5 Spectral Heralds in the Shattered Vestibule - Royal Audience Chamber',
    zoneId: 6,
    objective_type: 'kill',
    objective_target: 'Spectral Herald',
    objective_count: 5,
    reward_type: 'xp',
    reward_value: 60,
    reward_amount: 60,
  },
  {
    id: 17,
    title: 'Tides of Fate',
    description: 'Retrieve the Tidal Amulet from the Flooded Catacombs - Tidal Tombs',
    zoneId: 7,
    objective_type: 'find',
    objective_target: 'Tidal Amulet',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Minor Mana Shard',
    reward_amount: 3,
  },
  {
    id: 18,
    title: 'Ink and Secrets',
    description: 'Defeat 6 Ink Specters in the Flooded Catacombs - Sunken Library',
    zoneId: 8,
    objective_type: 'kill',
    objective_target: 'Ink Specter',
    objective_count: 6,
    reward_type: 'xp',
    reward_value: 70,
    reward_amount: 70,
  },
  {
    id: 19,
    title: 'Abyssal Hunt',
    description: 'Eliminate 4 Abyssal Eels in the Flooded Catacombs - Abyssal Cistern',
    zoneId: 9,
    objective_type: 'kill',
    objective_target: 'Abyssal Eel',
    objective_count: 4,
    reward_type: 'item',
    reward_value: 'Ectoplasm Bomb',
    reward_amount: 1,
  },
  {
    id: 20,
    title: 'Forge the Flame',
    description: 'Find the Ember Core in the Obsidian Forges - Smoldering Anvils',
    zoneId: 10,
    objective_type: 'find',
    objective_target: 'Ember Core',
    objective_count: 1,
    reward_type: 'gold',
    reward_value: 80,
    reward_amount: 80,
  },
  {
    id: 21,
    title: 'Conveyor Chaos',
    description: 'Defeat 5 Ember Fiends in the Obsidian Forges - Forge Depths',
    zoneId: 11,
    objective_type: 'kill',
    objective_target: 'Ember Fiend',
    objective_count: 5,
    reward_type: 'xp',
    reward_value: 90,
    reward_amount: 90,
  },
  {
    id: 22,
    title: 'Crucible Challenge',
    description: 'Eliminate 3 Crucible Guardians in the Obsidian Forges - Molten Crucible',
    zoneId: 12,
    objective_type: 'kill',
    objective_target: 'Crucible Guardian',
    objective_count: 3,
    reward_type: 'item',
    reward_value: 'Tome Guardian’s Shield',
    reward_amount: 1,
  },
  {
    id: 23,
    title: 'Foundry Foes',
    description: 'Defeat 6 Foundry Constructs in the Obsidian Forges - Ashen Foundry',
    zoneId: 13,
    objective_type: 'kill',
    objective_target: 'Foundry Construct',
    objective_count: 6,
    reward_type: 'xp',
    reward_value: 100,
    reward_amount: 100,
  },
  {
    id: 24,
    title: 'Shatter the Veil',
    description: 'Find the Veil Shard in the Veilspires - Crystal Spires',
    zoneId: 14,
    objective_type: 'find',
    objective_target: 'Veil Shard',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Spectral Bow',
    reward_amount: 1,
  },
  {
    id: 25,
    title: 'Nexus Purge',
    description: 'Eliminate 4 Veil Lords in the Veilspires - Soulrift Nexus',
    zoneId: 15,
    objective_type: 'kill',
    objective_target: 'Veil Lord',
    objective_count: 4,
    reward_type: 'xp',
    reward_value: 120,
    reward_amount: 120,
  },
  {
    id: 26,
    title: 'Bridge of Peril',
    description: 'Defeat 5 Void Serpents in the Veilspires - Ethereal Bridges',
    zoneId: 16,
    objective_type: 'kill',
    objective_target: 'Void Serpent',
    objective_count: 5,
    reward_type: 'gold',
    reward_value: 100,
    reward_amount: 100,
  },
  {
    id: 27,
    title: 'Heart of the Veil',
    description: 'Retrieve the Crystal Heart Fragment in the Veilspires - Crystal Heart',
    zoneId: 17,
    objective_type: 'find',
    objective_target: 'Crystal Heart Fragment',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Frosted Blade',
    reward_amount: 1,
  },
  {
    id: 28,
    title: 'Gauntlet of Shadows',
    description: 'Defeat 7 King’s Shades in the Throne of Eternity - Guardian’s Gauntlet',
    zoneId: 18,
    objective_type: 'kill',
    objective_target: 'King’s Shade',
    objective_count: 7,
    reward_type: 'xp',
    reward_value: 150,
    reward_amount: 150,
  },
  {
    id: 29,
    title: 'Reflections of Power',
    description: 'Find the Memory Crystal in the Throne of Eternity - Hall of Reflections',
    zoneId: 20,
    objective_type: 'find',
    objective_target: 'Memory Crystal',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Veil Shard',
    reward_amount: 1,
  },
  {
    id: 30,
    title: 'Bone Maze Trials',
    description: 'Eliminate 5 Bone Behemoths in the Hollow Depths - Bone Labyrinth',
    zoneId: 22,
    objective_type: 'kill',
    objective_target: 'Bone Behemoth',
    objective_count: 5,
    reward_type: 'xp',
    reward_value: 160,
    reward_amount: 160,
  },
  {
    id: 31,
    title: 'Ectoplasmic Surge',
    description: 'Retrieve the Ectoplasm Core in the Hollow Depths - Ectoplasmic Veins',
    zoneId: 23,
    objective_type: 'find',
    objective_target: 'Ectoplasm Core',
    objective_count: 1,
    reward_type: 'gold',
    reward_value: 120,
    reward_amount: 120,
  },
  {
    id: 32,
    title: 'Scout the Halls',
    description: 'Explore the Shattered Vestibule - Entry Hall and report the number of Skeletons and Bone Rats to the Hollow Merchant',
    zoneId: 1,
    objective_type: 'explore',
    objective_target: 'Skeleton and Bone Rat count',
    objective_count: 1,
    reward_type: 'gold',
    reward_value: 20,
    reward_amount: 20,
  },
  {
    id: 33,
    title: 'Silence the Song',
    description: 'Defeat a specific Spectral Siren in the Flooded Catacombs - Drowned Passage for the Drowned Oracle',
    zoneId: 5,
    objective_type: 'kill',
    objective_target: 'Spectral Siren',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Siren’s Charm',
    reward_amount: 1,
  },
  {
    id: 34,
    title: 'Fuel the Forge',
    description: 'Defeat 2 Ember Spirits in the Obsidian Forges - Smoldering Anvils to help the Ember Scribe',
    zoneId: 10,
    objective_type: 'kill',
    objective_target: 'Ember Spirit',
    objective_count: 2,
    reward_type: 'item',
    reward_value: 'Ember Pendant',
    reward_amount: 1,
  },
  {
    id: 35,
    title: 'Mage’s Experiment',
    description: 'Collect 5 Veil Shards in the Veilspires - Soulrift Nexus for the Exiled Mage',
    zoneId: 15,
    objective_type: 'gather',
    objective_target: 'Veil Shard',
    objective_count: 5,
    reward_type: 'xp',
    reward_value: 100,
    reward_amount: 100,
    secondary_reward: { reward_type: 'item', reward_value: 'Veil Shard', reward_amount: 1 },
  },
  {
    id: 36,
    title: 'Clear the Reflections',
    description: 'Defeat a Mirror Doppelganger in the Hall of Reflections - Mirror Maze for the Mirror Seer',
    zoneId: 20,
    objective_type: 'kill',
    objective_target: 'Mirror Doppelganger',
    objective_count: 1,
    reward_type: 'xp',
    reward_value: 80,
    reward_amount: 80,
  },
  {
    id: 37,
    title: 'Guard the Crypts',
    description: 'Defeat 5 Skeletal Archers in the Shattered Vestibule - Guarded Crypts for the Crypt Guard',
    zoneId: 4,
    objective_type: 'kill',
    objective_target: 'Skeletal Archer',
    objective_count: 5,
    reward_type: 'xp',
    reward_value: 30,
    reward_amount: 30,
  },
  {
    id: 38,
    title: 'Chronicle the Past',
    description: 'Find a Royal Relic in the Shattered Vestibule - Royal Audience Chamber for the Royal Chronicler',
    zoneId: 6,
    objective_type: 'find',
    objective_target: 'Royal Relic',
    objective_count: 1,
    reward_type: 'item',
    reward_value: 'Spectral Shard',
    reward_amount: 1,
  },
  {
    id: 39,
    title: 'Dive into the Abyss',
    description: 'Defeat 3 Abyssal Eels in the Flooded Catacombs - Abyssal Cistern for the Abyssal Diver',
    zoneId: 9,
    objective_type: 'kill',
    objective_target: 'Abyssal Eel',
    objective_count: 3,
    reward_type: 'xp',
    reward_value: 50,
    reward_amount: 50,
  },
  {
    id: 40,
    title: 'Clear the Forge Depths',
    description: 'Defeat 4 Ember Fiends in the Obsidian Forges - Forge Depths for the Forge Worker',
    zoneId: 11,
    objective_type: 'kill',
    objective_target: 'Ember Fiend',
    objective_count: 4,
    reward_type: 'item',
    reward_value: 'Ember Shard',
    reward_amount: 1,
  },
  {
    id: 41,
    title: 'Gather Crystal Shards',
    description: 'Collect 3 Crystal Shards in the Veilspires - Crystal Spires for the Crystal Sage',
    zoneId: 14,
    objective_type: 'gather',
    objective_target: 'Crystal Shard',
    objective_count: 3,
    reward_type: 'xp',
    reward_value: 60,
    reward_amount: 60,
  },
  {
    id: 42,
    title: 'Survive the Gauntlet',
    description: 'Defeat 5 King’s Shades in the Throne of Eternity - Guardian’s Gauntlet for the Gauntlet Sentinel',
    zoneId: 18,
    objective_type: 'kill',
    objective_target: 'King’s Shade',
    objective_count: 5,
    reward_type: 'item',
    reward_value: 'King’s Crest',
    reward_amount: 1,
  },
  {
    id: 43,
    title: 'Endure the Sands',
    description: 'Defeat 4 Sand Wraiths in the Cursed Expanse Wastes - Blighted Sands for the Sand Nomad',
    zoneId: 24,
    objective_type: 'kill',
    objective_target: 'Sand Wraith',
    objective_count: 4,
    reward_type: 'xp',
    reward_value: 70,
    reward_amount: 70,
  },
  {
    id: 44,
    title: 'Hunt the Tundra',
    description: 'Defeat 3 Frost Wolves in the Frostfang Tundra - Icebound Hollow for the Frost Hunter',
    zoneId: 27,
    objective_type: 'kill',
    objective_target: 'Frost Wolf',
    objective_count: 3,
    reward_type: 'item',
    reward_value: 'Frost Wolf Pelt',
    reward_amount: 1,
  },
  {
    id: 45,
    title: 'Protect the Vines',
    description: 'Collect 5 Thorned Vines in the Verdant Abyss - Overgrown Depths for the Vine Warden',
    zoneId: 31,
    objective_type: 'gather',
    objective_target: 'Thorned Vine',
    objective_count: 5,
    reward_type: 'xp',
    reward_value: 80,
    reward_amount: 80,
  },
  {
    id: 46,
    title: 'Tame the Storm',
    description: 'Defeat 3 Storm Ravens in the Stormwracked Ridge - Storm’s Eye for the Storm Sentinel',
    zoneId: 35,
    objective_type: 'kill',
    objective_target: 'Storm Raven',
    objective_count: 3,
    reward_type: 'item',
    reward_value: 'Storm Raven Feather',
    reward_amount: 1,
  },
  {
    id: 47,
    title: 'Harvest the Bog',
    description: 'Collect 4 Murkshade Roots in the Veilswamp - Murkshade Bog for the Bog Witch',
    zoneId: 37,
    objective_type: 'gather',
    objective_target: 'Murkshade Root',
    objective_count: 4,
    reward_type: 'xp',
    reward_value: 90,
    reward_amount: 90,
  },
];
  
export function getNpcsByZone(zoneId) {
  return npcs.filter(npc => npc.zoneId === zoneId);
}

export function getQuestsByZone(zoneId) {
  return quests.filter(quest => quest.zoneId === zoneId);
}

export function getQuestById(questId) {
  return quests.find(quest => quest.id === questId);
}